import React from 'react'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { IoIosArrowDown } from "react-icons/io";
import { useTranslation } from 'react-i18next';

const LanguagesDrop = (props) => {
  const { t , i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
    // Map language codes to country codes for flags
    const languageToCountry = {
      fr: 'fr', // France
      en: 'us', // United States
      ar: 'ma'  // Morocco
    };
  
    // Get current flag based on selected language
    const getCurrentFlag = () => {
      const countryCode = languageToCountry[i18n.language] || 'FR';
      return `https://hatscripts.github.io/circle-flags/flags/${countryCode}.svg`;
      // return `https://flagsapi.com/${countryCode}/flat/64.png`;
    };

  return (
    <Menu as="div" className={`relative inline-block text-left ${isRTL ? '!font-almarai' : 'font-inter'}`}>
      <div className={`flex justify-center items-center gap-2 ${isRTL ? 'mr-2' : 'ml-2'}`}>
        <MenuButton className={`flex justify-center items-center gap-2 p-1 px-2 xxxxl:p-2 rounded-lg ${props.className} shadow-sm`}>
          <div className="w-7 aspect-square rounded-full overflow-hidden flex justify-center items-center ">
            <img 
                  src={getCurrentFlag()} 
                  alt="Selected Language Flag" 
                  className="w-full aspect-square rounded-full object-cover"
                />
          </div>
          {languageToCountry[i18n.language]}
          <div className={`flex justify-center items-center border-[1px] border-secondary rounded-full `}>
            <IoIosArrowDown size={props.w}  aria-hidden="true" className={`${props.icoclass}`}/>
          </div>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className={`absolute ${isRTL ? 'left-2' : 'right-2'} z-[100000] mt-2 w-auto rounded-md ${props.classN1} shadow-lg transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in`}
      >
        <div className="py-1 flex flex-col">
          <MenuItem>
            <button onClick={() => changeLanguage('fr')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              FR
            </button>
          </MenuItem>
          <MenuItem>
            <button onClick={() => changeLanguage('en')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              EN
            </button>
          </MenuItem>
          <MenuItem>
            <button onClick={() => changeLanguage('ar')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              AR
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}

export default LanguagesDrop
